module.exports = __webpack_public_path__ + "static/media/blackDisabledEventIcon.0b5863e8.svg";